import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from 'store/slices/userInfoSlice';
import ClientIcon from '../../atoms/ClientIcon/ClientIcon';

const useStyles = makeStyles((theme: Theme) => ({
    clientIcon: {
        height: '40px',
        width: '40px',
        flexShrink: 0,
        cursor: 'pointer',
    },
    userInfo: {
        color: '#fff',
        display: 'flex',
        overflow: 'hidden',
        justifyContent: 'flex-end',
        alignItems: 'center',
        height: '100%',
    },
    userName: {
        fontSize: '18px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flexShrink: 1,
        overflow: 'hidden',
        marginLeft: '20px',
        cursor: 'pointer',
    },
    menuItem: {
        padding: '0',
    },
    link: {
        width: '100%',
        height: '100%',
        display: 'block',
        textDecoration: 'none',
        padding: '6px 16px',
        color: theme.palette.text.primary,
        '&:active, &:visited': {
            color: theme.palette.text.primary,
        },
        '&:focus': {
            color: theme.palette.primary.light,
        },
    },
}));

interface Props {
    userName: string;
    url: string;
    page: string;
}

const UserInfo = ({ userName, url }: Props) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleClose();
        dispatch(logout());
        history.push('/login');
    };

    return (
        <Box className={classes.userInfo}>
            <ClientIcon userName={userName} className={classes.clientIcon} />
            <Box
                onClick={handleClick}
                className={classes.userName}
                color={url === '/' ? '#383b5b' : '#fff'}
            >
                {userName}
            </Box>
            <Menu
                style={{
                    top: '30px',
                }}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem className={classes.menuItem} onClick={handleClose}>
                    <Link className={classes.link} to="/cabinet/profile">
                        Профиль
                    </Link>
                </MenuItem>
                <MenuItem className={classes.menuItem} onClick={handleClose}>
                    <Link className={classes.link} to="/cabinet/reset-password">
                        Сменить пароль
                    </Link>
                </MenuItem>
                <MenuItem onClick={handleLogout}>Выйти</MenuItem>
            </Menu>
        </Box>
    );
};

export default UserInfo;
